export default __webpack_public_path__ + "static/media/warning.0175d9eb.svg";